<div class="dialog">
    <h2 mat-dialog-title>{{ local_data.data.title }}</h2>
    <form [formGroup]="formGroup">
        <mat-form-field class="textarea-dialog" appearance="outline">
                <!-- <mat-label>{{local_data.data.commentaryLabel}}</mat-label> -->
            <textarea 
                formControlName="commentaryCtrl"
                matInput 
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5">
                
            </textarea> 
        </mat-form-field> 
    </form>
    <div class="dialog-box-s">
        <mat-dialog-actions class="button-group">
            <app-button typeBtn="secondary" color="red" textColor="white" message="{{variables.cancel}}" mat-dialog-close ></app-button>
            <app-button typeBtn="primary" message="{{variables.send}}" (click)="doAction()"></app-button>
        </mat-dialog-actions>
    </div>
</div>